export const MAX_SEARCH_LENGTH = 200;
export const MAX_SERVER_LIMIT = 100;
export const MAX_TAG_LENGTH = 30;
export const MAX_VIDEO_TAG_LENGTH = 80;
export const MAX_CATEGORY_LENGTH = 50;
export const MAX_RECOMMENDED_COURSE_LABEL_LENGTH = 36;
